import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const DownloadFileIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Download File`} {...props}>
    <Path
      fill="#001A19"
      d="M14 10.25a.75.75 0 0 1 .75.75v2.667c0 1.15-.933 2.083-2.083 2.083H3.333a2.083 2.083 0 0 1-2.083-2.083V11a.75.75 0 0 1 1.5 0v2.667c0 .322.261.583.583.583h9.334a.583.583 0 0 0 .583-.583V11a.75.75 0 0 1 .75-.75Zm-6-10a.75.75 0 0 1 .75.75v7.19l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3-.056.052c-.01.008-.023.014-.034.021a.71.71 0 0 1-.26.122l-.06.014-.034.005A.739.739 0 0 1 8 10.75l-.026-.002a.636.636 0 0 1-.134-.017.741.741 0 0 1-.098-.03c-.012-.004-.026-.006-.038-.011-.028-.013-.054-.03-.08-.045a.748.748 0 0 1-.154-.115l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72V1A.75.75 0 0 1 8 .25Z"
    />
  </Icon>
);
